module.exports = __webpack_public_path__ + "img/MP-Habitat-Logo-Light.ef769fd6.svg";